export const EMPLOYEE_API={
    EMPLOYEE_CREATE:{url:"/employee/", method:"POST"},
    EMPLOYEE_UPDATE:{url:"/employee/", method:"PUT"},
    EMPLOYEE_DELETE:{url:"/employee/", method:"DELETE"},
    EMPLOYEE_LIST:{url:"/employee/", method:"GET"},
    MASTER_EMPLOYEE_LIST:{url:"/employee/admin/master", method:"GET"},
    
    };